<div class='ingredient-info' [attr.aria-hidden]="isRadioButton">
  <div class="ingredient-label-and-calories ingredient-label">
    <p class='no-margin primary-text-color ingredient-name'>{{ingredient.name}}</p>
    <p class='no-margin calories fw-300' *ngIf='calories !== undefined || (showIngredientPrices && displayedIngredientPrice)'>
      <span *ngIf='showIngredientPrices && displayedIngredientPrice' class='ingredient-price'>
        {{displayedIngredientPrice | currency:'USD':'symbol'}}
      </span>
      <ng-container *ngIf="storeConfig?.showCalories && !isUnavailable">
        <span *ngIf='calories !== undefined && showIngredientPrices && displayedIngredientPrice'> - </span>
        <span *ngIf='calories !== undefined'>
          {{'component.item_editor.choice.ingredient_info.calories' | translate:{calories: calories} }}
          <span *ngIf='servingLabel'>{{'component.item_editor.choice.ingredient_info.per' | translate:{label: servingLabel} }}</span>
        </span>
      </ng-container>
    </p>
  </div>
  <div class='extra-info text-right m-0' *ngIf='isUnavailable'>
    <p *ngIf='!storeConfig?.showSizeSpecificIngredients' class="no-margin text-danger">{{'component.item_editor.choice.ingredient_info.not_available' | translate}}</p>
    <p *ngIf='storeConfig?.showSizeSpecificIngredients' class="no-margin text-danger wrap">{{'component.item_editor.choice.ingredient_info.not_available_size' | translate : { sizes: availableSizes} }}</p>
  </div>
</div>
<div class='extra-info text-right' *ngIf='!isUnavailable && ingredient.description'>
  <button *ngIf="(breakPointService.isXSMobile$ | async)"
          class="btn btn-sm btn-link btn-undecorated web-description visible-xs-inline ingredient-help font-secondary"
          [ngbPopover]="description"
          popoverClass="popover-arrow-shadow"
          [placement]="'left'"
          #descriptionBtn
          (click)="ingredientDescriptionClicked($event)">
    <fa-icon [icon]="faQuestionCircle" class="text-muted  fa-icon-svg-vertical-top" size="lg"></fa-icon>
    <span class="sr-only">{{'component.item_editor.choice.ingredient_info.ingredient_description' | translate}}</span>
  </button>
  <button *ngIf="(breakPointService.isMobile$ | async)"
          class="btn btn-sm btn-link btn-undecorated web-description visible-xs-inline visible-sm-inline ingredient-help font-secondary"
          [ngbPopover]="description"
          popoverClass="popover-arrow-shadow"
          [placement]="(isPopOverLeft || inItemEditorModal) ? 'left' : 'right'"
          #descriptionBtn
          (click)="ingredientDescriptionClicked($event)">
    <fa-icon [icon]="faQuestionCircle" class="text-muted  fa-icon-svg-vertical-top" size="lg"></fa-icon>
    <span class="sr-only">Ingedient Description</span>
  </button>
  <button *ngIf="!(breakPointService.isTabletDown$ | async) && !(breakPointService.isMobile$ | async)"
          class="btn btn-sm btn-link btn-undecorated web-description ingredient-help font-secondary"
          [ngbPopover]="description"
          popoverClass="popover-arrow-shadow"
          [placement]="(isPopOverLeft || inItemEditorModal) ? 'left' : 'right'"
          #descriptionBtn
          (click)="ingredientDescriptionClicked($event)">
    <fa-icon [icon]="faQuestionCircle" class="text-muted  fa-icon-svg-vertical-top" size="lg"></fa-icon>
    <span class="sr-only primary-bg-color primary-text-color">{{'component.item_editor.choice.ingredient_info.ingredient_description' | translate}}</span>
  </button>
</div>

<ng-template #description>
  <div class='primary-bg-color primary-text-color text-center web-description-popover-body' [ngClass]="{'popover-width': inItemEditorModal && !(breakPointService.isTabletDown$ | async)}">
    <span><span class="sr-only">{{'component.item_editor.choice.ingredient_info.popover_message' | translate}}</span>{{ingredient.description}}</span>
  </div>
</ng-template>
